module.exports = __webpack_public_path__ + "img/icon_join.bc40c424.svg";